import React, { useState, useRef, useEffect } from "react";
import { useSpring, animated, easings } from "react-spring";
// import Logo from "../../Images/logo.png";

import {
    OpenAIOutlined,
    UserOutlined,
} from "@ant-design/icons";

import Logo from "../../Images/logo2.png";
import Lottie from 'react-lottie-player'
import { Loading } from "../../Components/Lottie/Loading";
import { Collapse } from "antd";
// import { returnMockData, returnMockDataSource } from "../../Services/mockData";

import Probing from "../../Components/Probing/Probing";
import Sources from "../../Components/Sources/Sources";
import Pakages from "../../Components/Pakages/Pakages";
import PdmPacks from "../../Components/Pakages/PdmPacks";
import PdmChannels from "../../Components/Pakages/PdmChannels";
import RestartChat from "../../Components/RestartChat/RestartChat";
import UnderDevelopent from "../../Components/Pakages/UnderDevelopent";
import PdmSingles from "../../Components/Pakages/PdmSingles";
import LoadingDots from "../../Components/Lottie/LoadingDots";
import Regenerate from "../../Components/Regenerate/Regenerate";
import FeedbackPopUp from "../../Components/FeedbackPopUp/FeedbackPopUp";
import apiService from "../../Services/apiServices";






const Conversation = (props) => {
    const { setShowMsgs,
        showMsgs,
        messages,
        updateMessage, 
        setIsFeedbackPop, 
        clearMessages, 
        loading, 
        showMaximumChat, 
        scrollToBottom, 
        isFeedbackPop, 
        token, 
        sessionId, 
        startLogin, 
        setIsThirtyMinPopUP, 
        IsThirtyMinPopUP, 
        setIsShowBot, 
        setDisableInputBox,
        checkThumsDownFeedback,
        setCheckThumsDownFeedback,
        setIndexForPopUp,
    } = props


    const [showBotFlow, isSetBotFlow] = useState(false);
    const [toggleListIcon, setToggleListIcon] = useState(false)
    const [messageBoard, setMessageBoard] = useState(false);
    
    const fadeInProps = useSpring({
        from: { opacity: Math.random() },
        to: { opacity: 1 },
        config: { duration: 1000, easing: easings.easeInOut },
        // Adjust duration and easing as needed
    });

    const customerStyles = {
        from: { transform: 'translateX(100%)' },
        to: { transform: 'translateX(0%)' },
        config: { duration: 1000, easing: easings.easeInOut }
    };


    const handelThum = () => {
        setIsFeedbackPop(true)
    }




    //Load Message
    const showMsgWindow = () => {

        return (
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    height: "100%",
                    flexDirection: "column",
                }}
            >
                <img style={{ width: messages?.length === 0 && showMaximumChat ? '574px' : "250px" }} alt="botLogo" src={Logo}></img>
                <div className={messages?.length === 0 && showMaximumChat ? 'helper-no-msg' : "helper-msg"}> How can I Help you today?</div>
            </div>

        )
    }

    //load end chat 
    const endChat = () =>{
        return (
            <div style={{width : showMaximumChat && '30%'}} className="restart-pop-up">
                    <p className="idle-msg-container-content">
                    <span style={{ fontWeight: "bold" , fontFamily :'sans-serif' }}>
                        Since it's been a while and there is no revert from you
                        yet, we'll have to close the chat window. But drop by
                        again anytime in case you start missing us. We loved
                        hearing from you. Have a great day!
                    </span>
                    <div style={{width : '100%' , display : 'flex' , justifyContent : 'center'}}>
                        <button
                            onClick={() => {
                            setIsThirtyMinPopUP(false)
                            clearMessages()
                            apiService.loginForRefresh('6')
                            // startLogin()
                            setShowMsgs(false)
                            setIsShowBot(false)
                            setDisableInputBox(false)
                            }}
                            style={{
                                background: "#D02F92",
                                border: "1px solid white",
                                borderRadius: "5px",
                                color: "white",
                                width: "6rem",
                                fontSize: "small",
                                cursor: 'pointer',
                                marginTop : '12px',
                                height : '30px'
                            }}
                        >
                            End Chat
                        </button>
                    </div>
                </p>
                </div>
        )
    }


    const loadLottie = () => {
        return (
            <div style={{ width: '10rem', height: '10rem', margin: 'auto', marginTop: '3rem' }}> <Lottie
                    loop
                    animationData={Loading}
                    play
                style={{ width: 150, height: 150 }}
            /></div>
        )
    }

    const loadCxMsg = (msg) => {
        return (
            <>

                <div className="oneConversation-left-text-customer" style={customerStyles}>
                    {showMaximumChat ?
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "end",
                                alignItems: "center",
                                textAlign: 'end',
                                gap: '5px'
                                // marginRight: "9rem"
                            }}
                        >
                            {" "}
                            <div style={{whiteSpace : showMaximumChat && 'nowrap'}} className="customer-text">
                                {msg.text}
                            </div>
                            <div style={{ minWidth: '40px', minHeight: '40px', background: '#E20092', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '50%' }}>

                                <UserOutlined style={{ color: 'white' }} />
                            </div>
                        </div>
                        :
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "end",
                                alignItems: "center",
                                textAlign: 'end',
                                width: "100%"
                            }}
                        >
                            {" "}
                            <div style={{whiteSpace : showMaximumChat && 'nowrap'}} className="customer-text">
                                {msg.text}
                            </div>
                            <div style={{ width: '4vh', height: '4vh', background: '#E20092', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '50%' }}>

                                <UserOutlined style={{ color: 'white' }} />
                            </div>
                        </div>}
                    <div
                        className="user-time"
                        style={fadeInProps}
                    >
                        {msg?.time}
                    </div>
                </div>

            </>
        )
    }
    const loadProbingSection = (msg ,index) => {
        return (
            <div
                className="server-probe-response-body"
                style={fadeInProps}
            >
                <Probing setIsFeedbackPop={setIsFeedbackPop} data={msg} scrollToBottom={scrollToBottom} setMessageBoard={setMessageBoard} messageBoard={messageBoard} showMaximumChat={showMaximumChat} />
                {/* //Regenerate */}
                <Regenerate index ={index} msg={msg} messages={messages} fadeInProps={fadeInProps} updateMessage={updateMessage} showMaximumChat={showMaximumChat} setIsFeedbackPop={setIsFeedbackPop} token={token} sessionId={sessionId} checkThumsDownFeedback={checkThumsDownFeedback} />
            </div>
        )
    }



    const loadChatMessages = (msg ,index) => {

        if(msg?.isFailed || msg?.messageType === "UnderDevelopment"){
            return(
            <UnderDevelopent
            data={msg}
            showMaximumChat={showMaximumChat}
            loading={loading}
            setIsFeedbackPop={setIsFeedbackPop}
            updateMessage={updateMessage}
            index={index}
            messages={messages}
            sessionId={sessionId}
            checkThumsDownFeedback={checkThumsDownFeedback}
            />

            )
        }

        if (msg?.messageType === "") {
          return (
            <Pakages
              showMaximumChat={showMaximumChat}
              msg={msg}
              updateMessage={updateMessage}
            />
          );
        }

        if (msg?.messageType === "pdm_packs") {
          return (
            <PdmPacks
              data={msg}
              showMaximumChat={showMaximumChat}
              loading={loading}
              setIsFeedbackPop={setIsFeedbackPop}
              updateMessage={updateMessage}
              index={index}
              messages={messages}
              sessionId={sessionId}
              checkThumsDownFeedback={checkThumsDownFeedback}
            />
          );
        }
        if (msg?.messageType === "pdm_channel") {
          return (
            <PdmChannels
              data={msg}
              showMaximumChat={showMaximumChat}
              loading={loading}
              setIsFeedbackPop={setIsFeedbackPop}
              updateMessage={updateMessage}
              index={index}
              messages={messages}
              sessionId={sessionId}
              checkThumsDownFeedback={checkThumsDownFeedback}
            />
          );
        }
        // if (msg?.messageType === "UnderDevelopment") {
        //   return (
        //     <UnderDevelopent
        //       data={msg}
        //       showMaximumChat={showMaximumChat}
        //       setIsFeedbackPop={setIsFeedbackPop}
        //       loading={loading}
        //       messages={messages}
        //       sessionId={sessionId}
        //       updateMessage={updateMessage}
        //     />
        //   );
        // }
        if (msg?.messageType === "pdm_single") {
          return (
            <PdmSingles
              data={msg}
              showMaximumChat={showMaximumChat}
              loading={loading}
              setIsFeedbackPop={setIsFeedbackPop}
              updateMessage={updateMessage}
              index={index}
              messages={messages}
              sessionId={sessionId}
              checkThumsDownFeedback={checkThumsDownFeedback}
            />
          );
        }

        
        return <>{loadProbingSection(msg ,index)}</>

    }


    //main UI---------------------------------------------------
    return (

        <>
            {!showMsgs ? (
               IsThirtyMinPopUP ? endChat() : showMsgWindow()
            ) : (

                <animated.div style={fadeInProps}>
                    {messages?.length > 0 ?
                            (
                                <div
                                    className="conversationContainer"
                                    style={{
                                        width: showMaximumChat ? "100%" : "95%"
                                    }}
                                >

                                    {messages.map((msg, index) => (
                                        <animated.div className="oneConversation" style={fadeInProps}>
                                            <div
                                                className="oneConversation-left"
                                                style={{ width: !showMaximumChat ? "100%" : "90%" }}
                                            >
                                                {msg?.type === "CUSTOMER" ? (                    //Coustomer
                                                    <>{loadCxMsg(msg)}</>
                                                ) : (
                                                    <div
                                                        className="oneConversation-left-text-server"
                                                        style={fadeInProps}
                                                    >
                                                        {/* <OpenAIOutlined className="bot-reply-icon" /> */}
                                                        <img
                                                            className="bot-reply-icon" 
                                                            style={{width : '4vh' ,height : '4vh'}}
                                                            alt="src"
                                                            src={'data:image/png;base64,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'}
                                                        ></img>
                                                        <div
                                                            className={index === messages?.length - 1 && loading ? 'oneConversation-left-text-server-content-loading' :"oneConversation-left-text-server-content"}
                                                            style={fadeInProps}
                                                        >
                                                             {index === messages?.length - 1 && loading ? <LoadingDots/> : loadChatMessages(msg ,index)}   
                                                        </div>
                                                        <div
                                                            className="customer-time"
                                                            style={fadeInProps}
                                                        >
                                                            {msg?.time}
                                                        </div>
                                                        {setIndexForPopUp(index)}
                                                        {msg.type !== "CUSTOMER" && showMaximumChat && !messageBoard && msg?.llm_response?.webpage && (
                                                            <Sources msg ={msg?.llm_response?.webpage} title ={msg?.llm_response?.source_title} showMaximumChat={showMaximumChat} clearMessages={clearMessages} setShowMsgs={setShowMsgs} />
                                                        )}
                                                      
                                                        {!showMaximumChat && isFeedbackPop && index === messages?.length - 1 && <FeedbackPopUp setIsFeedbackPop={setIsFeedbackPop} showMaximumChat={showMaximumChat} sessionId={sessionId} setCheckThumsDownFeedback={setCheckThumsDownFeedback} messages={messages} index={index} checkThumsDownFeedback={checkThumsDownFeedback}/>}

                                                        {index === messages.length - 1 && !isFeedbackPop && !loading && (
                                                            <RestartChat showMaximumChat={showMaximumChat} clearMessages={clearMessages} setShowMsgs={setShowMsgs} startLogin={startLogin} setCheckThumsDownFeedback={setCheckThumsDownFeedback}/>
                                                        )}

                                                    </div>
                                                )}

                                            </div>
                                            <div className="line-divider"></div>
                                        </animated.div>
                                    ))}
                                </div>
                            ) : (
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        width: "100%",
                                        justifyContent: "center",
                                        height: "100%",
                                        ...fadeInProps,
                                    }}
                                ></div>
                            )}
                </animated.div>

            )}
        </>

    );
};

export default Conversation;
